import React from 'react'

import Tooltip from '../Tooltip'
import { LegendData } from '../../types'

import * as Styled from './Legend.styled'

const LegendElement: React.FC<LegendData[number]> = ({ color, title, tooltip }) => (
  <Styled.Element>
    <Styled.Dot color={color} />
    <Styled.Text>
      {title}&nbsp;
      {tooltip && <Styled.Tooltip as={Tooltip}>{tooltip}</Styled.Tooltip>}
    </Styled.Text>
  </Styled.Element>
)

type Props = {
  data: LegendData
  hasData?: boolean
  Container?: React.ElementType
}

const Legend: React.FC<Props> = ({ data, hasData = true, Container = Styled.Container }) => {
  return (
    <Container>
      {data.map(({ color, title, tooltip }, index) => (
        <LegendElement
          key={index}
          color={hasData ? color : '#667399'}
          title={title}
          tooltip={tooltip}
        />
      ))}
    </Container>
  )
}

export default Legend
